import { Component, Input } from '@angular/core';
import { Planner } from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-planner-info',
  templateUrl: './planner-info.component.html',
  styleUrls: ['./planner-info.component.scss']
})
export class PlannerInfoComponent {
  @Input() planner: Planner = new Planner();
  @Input() columns = 2;
}
